import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=7cb719f6&scoped=true"
import script from "./Cooperation.vue?vue&type=script&lang=js"
export * from "./Cooperation.vue?vue&type=script&lang=js"
import style0 from "./Cooperation.vue?vue&type=style&index=0&id=7cb719f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb719f6",
  null
  
)

export default component.exports